import {
  SET_LOCALE,
  SET_PROGRESS,
  SET_MEMBERSHIP_CODE,
  SET_CONSUMER_NETWORK_UUID,
  SET_COOKIE_PREFERENCE,
  SET_PARTNER_SLUG,
  RESET_USER_CONFIG,
} from './constants'

const setLocale = (locale: string) => ({
  type: SET_LOCALE,
  payload: locale,
})

const setSignupProgress = (signupProgress: number) => ({
  type: SET_PROGRESS,
  payload: signupProgress,
})

const setMembershipCode = (membershipCode: string) => ({
  type: SET_MEMBERSHIP_CODE,
  payload: membershipCode,
})

const setConsumerNetworkUuid = (consumerNetworkUuid: string) => ({
  type: SET_CONSUMER_NETWORK_UUID,
  payload: consumerNetworkUuid,
})

const setCookiePreference = (accepted: Boolean) => ({
  type: SET_COOKIE_PREFERENCE,
  payload: accepted,
})

const setUserPartnerSlug = (partnerSlug: string) => ({
  type: SET_PARTNER_SLUG,
  payload: partnerSlug,
})

const resetUserConfig = () => ({
  type: RESET_USER_CONFIG,
})

export {
  setLocale,
  setSignupProgress,
  setMembershipCode,
  setConsumerNetworkUuid,
  setCookiePreference,
  setUserPartnerSlug,
  resetUserConfig,
}
